import { handleActions } from 'redux-actions';
import * as Actions from '../constants/actions';
import { StudentData, emptyStudent } from '../models/Student';

const initialState: StudentData = emptyStudent;

export default handleActions<StudentData, StudentData>(
	{
		[Actions.STUDENT_LOGIN]: (state, action) => {
			return Object.assign({}, action.payload);
		},

		[Actions.STUDENT_AUTHENTICATE]: (state, action) => {
			return Object.assign({}, action.payload);
		}
	},
	initialState
);



// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/reducers/student.ts